module.exports = __webpack_public_path__ + "static/media/down-arrow.40d7d285.svg";